import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Handshake, Building2, Heart } from 'lucide-react';
export function BecomePartner() {
  return <Section background="white" data-id="element-25">
      <div className="max-w-5xl mx-auto" data-id="element-26">
        <div className="text-center mb-12" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-28">
            Partner With Us
          </h2>
          <p className="text-lg md:text-xl font-inter text-neutral-charcoal max-w-3xl mx-auto" data-id="element-29">
            Healthcare facilities, medical suppliers, and organizations can join
            our mission to deliver essential supplies to underserved communities
            in Egypt.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-30">
          <div className="text-center" data-id="element-31">
            <div className="flex justify-center mb-4" data-id="element-32">
              <div className="h-16 w-16 rounded-full bg-primary-royal-blue/10 flex items-center justify-center" data-id="element-33">
                <Building2 size={32} className="text-primary-royal-blue" data-id="element-34" />
              </div>
            </div>
            <h3 className="text-xl font-playfair font-bold text-primary-deep-blue mb-3" data-id="element-35">
              Healthcare Facilities
            </h3>
            <p className="font-inter text-neutral-charcoal" data-id="element-36">
              Donate unused or surplus medical supplies and equipment to support
              monastery clinics.
            </p>
          </div>

          <div className="text-center" data-id="element-37">
            <div className="flex justify-center mb-4" data-id="element-38">
              <div className="h-16 w-16 rounded-full bg-primary-royal-blue/10 flex items-center justify-center" data-id="element-39">
                <Handshake size={32} className="text-primary-royal-blue" data-id="element-40" />
              </div>
            </div>
            <h3 className="text-xl font-playfair font-bold text-primary-deep-blue mb-3" data-id="element-41">
              Corporate Partners
            </h3>
            <p className="font-inter text-neutral-charcoal" data-id="element-42">
              Support our mission through sponsorships, matching gifts, or
              employee engagement programs.
            </p>
          </div>

          <div className="text-center" data-id="element-43">
            <div className="flex justify-center mb-4" data-id="element-44">
              <div className="h-16 w-16 rounded-full bg-primary-royal-blue/10 flex items-center justify-center" data-id="element-45">
                <Heart size={32} className="text-primary-royal-blue" data-id="element-46" />
              </div>
            </div>
            <h3 className="text-xl font-playfair font-bold text-primary-deep-blue mb-3" data-id="element-47">
              Community Organizations
            </h3>
            <p className="font-inter text-neutral-charcoal" data-id="element-48">
              Collaborate with us to expand our reach and impact in serving
              vulnerable populations.
            </p>
          </div>
        </div>

        <div className="bg-neutral-offwhite p-8 md:p-12 rounded-2xl text-center" data-id="element-49">
          <h3 className="text-2xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-50">
            Ready to Make a Difference Together?
          </h3>
          <p className="text-lg font-inter text-neutral-charcoal mb-6 max-w-2xl mx-auto" data-id="element-51">
            Partnership opportunities are flexible and tailored to your
            organization's capacity and goals. Let's discuss how we can work
            together.
          </p>
          <Button href="/partners" size="lg" data-id="element-52">
            Explore Partnership Opportunities
          </Button>
        </div>
      </div>
    </Section>;
}